import { useToggle, TwilioVerificationChannelEnum, User, APIResponse } from '@alluradirect/react';
import Grid from 'components/core/Grid';
import FormikPhoneNumber from 'components/formik/core/FormikPhoneNumber/FormikPhoneNumber';
import { VerifiedOrUnverifiedButton } from 'components/views/verification/components/VerifiedOrUnverifiedButton';
import { VerificationDialog } from 'components/views/verification/VerificationDialog';
import { useFormikContext } from 'formik';
import React from 'react';
import { useState } from 'react';

interface Props {
  initialPhoneData?: string;
  formikPrefix: string;
  isSmsVerified: boolean;
  userId: number;
}

export const AccountOwnerPhone = ({ formikPrefix, isSmsVerified, userId, initialPhoneData = '' }: Props) => {
  const { setFieldValue, setFieldTouched, validateField } = useFormikContext<any>();
  const phoneDialogToggle = useToggle();

  // re-render formikphonenumber to get updated value
  const [phoneKey, setPhoneKey] = useState(0);

  const onVerifySuccess = (data: APIResponse<{ USER: User }>) => {
    const phone = data?.DATA?.USER.PHONE;
    setFieldValue(`${formikPrefix}IS_SMS_VERIFIED`, true);
    setFieldValue(`${formikPrefix}PHONE`, phone);
    setFieldTouched(`${formikPrefix}PHONE`);
    validateField(`${formikPrefix}PHONE`);
    setPhoneKey(key => key + 1);
  };

  return (
    <>
      <Grid item xs={12} onClick={phoneDialogToggle.open}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <React.Fragment key={phoneKey}>
              <FormikPhoneNumber name={`${formikPrefix}PHONE`} disabled={true} />
            </React.Fragment>
          </Grid>
          <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
            <VerifiedOrUnverifiedButton
              formikName={`${formikPrefix}IS_SMS_VERIFIED`}
              isVerified={isSmsVerified}
              onClick={phoneDialogToggle.open}
              variant="outlined"
            />
          </Grid>
        </Grid>
      </Grid>

      {phoneDialogToggle.isOpen ? (
        <VerificationDialog
          initialData={initialPhoneData}
          isOpen={phoneDialogToggle.isOpen}
          handleClose={phoneDialogToggle.close}
          userId={userId}
          channel={TwilioVerificationChannelEnum.sms}
          onVerifySuccess={onVerifySuccess}
        />
      ) : null}
    </>
  );
};
